module.exports = __webpack_public_path__ + "static/media/patio.c42f3b72.svg";